export const getIntakeStepId = (no: number) => 'intake-step-' + no



// WEBPACK FOOTER //
// ./src/utils/getIntakeStepId.ts